import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  	* {
    	font-family: Avenir;
	}

	@font-face {
		src: url('./newAssets/fonts/Avenir/Avenir.ttc') format('truetype');
		font-weight: regular;
	}

	@font-face {
		font-family: AvenirNext;
		src: url('./newAssets/fonts/Avenir/AvenirNext.ttc') format('truetype');
		font-weight: bold;
	}

	@font-face {
		font-family: AvenirNextCondensed;
		src: url('./newAssets/fonts/Avenir/AvenirNextCondensed.ttc') format('truetype');
		font-weight: bold;
	}

  	body {
    	// background: radial-gradient(74.5% 111.75% at 49.73% 106.8%, #3B0864 0%, #200942 39%, #0B0B28 77%, #030B1E 100%);
		background-image: url('./newAssets/Hero/HeroBG-2.svg');
		background-repeat: no-repeat;
		background-position: 100% 100%;
		background-size: 100%;

    img {
		height: auto;
		max-width: 100%;
    }
	@media only screen and (max-width: 600px) {
		#root {
			background-image: url('./newAssets/Hero/HeroBG-2.svg');
			background-repeat: no-repeat;
			height: auto;
			background-position: bottom;
		}
	}
	
  }
`

export default GlobalStyle
